import React, { useState, useRef, useEffect } from "react";
import {
  Grid,
  Typography,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Button,
  TextField,
  withStyles,
  Icon,
  IconButton,
  Box,
} from "@material-ui/core";

import { URL } from "../../config/config";
import {
  Clear,
  Publish,
  Warning,
  CheckCircle,
  InfoOutlined,
} from "@material-ui/icons";
import axios from "axios";
import { Autocomplete } from "@material-ui/lab";
import RejectKyc from "./RejectKyc";
import { replaceDomainInData } from "../../helpers/mediaHelper";
import {
  BVBP_FILE_LIMIT_BYTES,
  bvbpUploadSizeWarning,
} from "../../helpers/bvbpHelper";

const currencyCode = [
  "AD",
  "AE",
  "AF",
  "AG",
  "AI",
  "AL",
  "AM",
  "AN",
  "AO",
  "AQ",
  "AR",
  "AS",
  "AT",
  "AU",
  "AW",
  "AX",
  "AZ",
  "BA",
  "BB",
  "BD",
  "BE",
  "BF",
  "BG",
  "BH",
  "BI",
  "BJ",
  "BL",
  "BM",
  "BN",
  "BO",
  "BQ",
  "BR",
  "BS",
  "BT",
  "BV",
  "BW",
  "BY",
  "BZ",
  "CA",
  "CC",
  "CD",
  "CF",
  "CG",
  "CH",
  "CI",
  "CK",
  "CL",
  "CM",
  "CN",
  "CO",
  "CR",
  "CU",
  "CV",
  "CW",
  "CX",
  "CY",
  "CZ",
  "DE",
  "DJ",
  "DK",
  "DM",
  "DO",
  "DZ",
  "EC",
  "EE",
  "EG",
  "EH",
  "ER",
  "ES",
  "ET",
  "FI",
  "FJ",
  "FK",
  "FM",
  "FO",
  "FR",
  "GA",
  "GB",
  "GD",
  "GE",
  "GF",
  "GG",
  "GH",
  "GI",
  "GL",
  "GM",
  "GN",
  "GP",
  "GQ",
  "GR",
  "GS",
  "GT",
  "GU",
  "GW",
  "GY",
  "HK",
  "HM",
  "HN",
  "HR",
  "HT",
  "HU",
  "ID",
  "IE",
  "IL",
  "IM",
  "IN",
  "IO",
  "IQ",
  "IR",
  "IS",
  "IT",
  "JE",
  "JM",
  "JO",
  "JP",
  "KE",
  "KG",
  "KH",
  "KI",
  "KM",
  "KN",
  "KP",
  "KR",
  "KW",
  "KY",
  "KZ",
  "LA",
  "LB",
  "LC",
  "LI",
  "LK",
  "LR",
  "LS",
  "LT",
  "LU",
  "LV",
  "LY",
  "MA",
  "MC",
  "MD",
  "ME",
  "MF",
  "MG",
  "MH",
  "MK",
  "ML",
  "MM",
  "MN",
  "MO",
  "MP",
  "MQ",
  "MR",
  "MS",
  "MT",
  "MU",
  "MV",
  "MW",
  "MX",
  "MY",
  "MZ",
  "NA",
  "NC",
  "NE",
  "NF",
  "NG",
  "NI",
  "NL",
  "NO",
  "NP",
  "NR",
  "NU",
  "NZ",
  "OM",
  "PA",
  "PE",
  "PF",
  "PG",
  "PH",
  "PK",
  "PL",
  "PM",
  "PN",
  "PR",
  "PS",
  "PT",
  "PW",
  "PY",
  "QA",
  "RE",
  "RO",
  "RS",
  "RU",
  "RW",
  "SA",
  "SB",
  "SC",
  "SD",
  "SE",
  "SG",
  "SH",
  "SI",
  "SJ",
  "SK",
  "SL",
  "SM",
  "SN",
  "SO",
  "SR",
  "SS",
  "ST",
  "SV",
  "SX",
  "SY",
  "SZ",
  "TC",
  "TD",
  "TF",
  "TG",
  "TH",
  "TJ",
  "TK",
  "TL",
  "TM",
  "TN",
  "TO",
  "TR",
  "TT",
  "TV",
  "TW",
  "TZ",
  "UA",
  "UG",
  "UM",
  "US",
  "UY",
  "UZ",
  "VA",
  "VC",
  "VE",
  "VG",
  "VI",
  "VN",
  "VU",
  "WF",
  "WS",
  "XK",
  "YE",
  "YT",
  "ZA",
  "ZM",
  "ZW",
];

const countryCode = [
  "AFN",
  "ALL",
  "DZD",
  "AOA",
  "ARS",
  "AMD",
  "AWG",
  "AUD",
  "AZN",
  "BSD",
  "BHD",
  "BDT",
  "BBD",
  "BYN",
  "BZD",
  "BMD",
  "BTN",
  "BOB",
  "BAM",
  "BWP",
  "BRL",
  "GBP",
  "BND",
  "BGN",
  "MMK",
  "BIF",
  "KHR",
  "CAD",
  "CVE",
  "KYD",
  "XAF",
  "XPF",
  "CLP",
  "CLF",
  "CNY",
  "COP",
  "KMF",
  "CDF",
  "CRC",
  "HRK",
  "CZK",
  "DKK",
  "DJF",
  "DOP",
  "XCD",
  "EGP",
  "ERN",
  "EEK",
  "ETB",
  "EUR",
  "FKP",
  "FJD",
  "GMD",
  "GEL",
  "GHS",
  "GIP",
  "GTQ",
  "GNF",
  "GYD",
  "HTG",
  "HNL",
  "HKD",
  "HUF",
  "ISK",
  "INR",
  "IDR",
  "IQD",
  "ILS",
  "JMD",
  "JPY",
  "JOD",
  "KZT",
  "KES",
  "KRW",
  "KWD",
  "KGS",
  "LAK",
  "LVL",
  "LBP",
  "LSL",
  "LRD",
  "LYD",
  "LTL",
  "MOP",
  "MKD",
  "MGA",
  "MWK",
  "MYR",
  "MVR",
  "MRO",
  "MUR",
  "MXN",
  "MDL",
  "MNT",
  "MAD",
  "MZN",
  "NAD",
  "NPR",
  "ANG",
  "NZD",
  "NIO",
  "NGN",
  "NOK",
  "OMR",
  "PKR",
  "PAB",
  "PGK",
  "PYG",
  "PEN",
  "PHP",
  "PLN",
  "QAR",
  "RON",
  "RUB",
  "RWF",
  "SHP",
  "SVC",
  "WST",
  "STD",
  "SAR",
  "RSD",
  "SCR",
  "SLE",
  "SLL",
  "SGD",
  "SKK",
  "SBD",
  "SOS",
  "ZAR",
  "SSP",
  "LKR",
  "SRD",
  "SZL",
  "SEK",
  "CHF",
  "TWD",
  "TJS",
  "TZS",
  "THB",
  "TOP",
  "TTD",
  "TND",
  "TRY",
  "TMT",
  "AED",
  "UGX",
  "UAH",
  "USD",
  "UYU",
  "UZS",
  "VUV",
  "VEF",
  "VES",
  "VND",
  "XOF",
  "YER",
  "ZMW",
  "ZWL",
  "FBZ",
];

const business_vertical = [
  "GROCERY_AND_CONVENIENCE_STORE",
  "AUTOMOTIVE_DEALERS",
  "RETAIL",
  "RESTAURANTS",
  "LOCAL_EVENTS",
  "PROFESSIONAL",
  "BUSINESS_AND_UTILITY",
  "HOME",
  "LIFESTYLE",
  "TRANSPORTATION_AND_ACCOMMODATION",
  "CONTENT_AND_APPS",
  "CREATORS_AND_CELEBRITIES",
  "HOME_AND_AUTO_MANUFACTURING",
  "NON_PROFIT_AND_RELIGIOUS_ORGS",
  "FIREARMS",
  "ALCOHOL_AND_TOBACCO",
  "DRUGS",
  "MEDICAL_HEALTHCARE",
  "ENDANGERED_SPECIES",
  "LIVE_NON_ENDANGERED_SPECIES",
  "HAZARDOUS_GOODS_AND_MATERIALS",
  "REAL_VIRTUAL_FAKE_CURRENCY",
  "BODY_PARTS_FLUIDS",
  "GAMBLING",
  "FRAUDULENT_MISLEADING_OFFENSIVE",
  "ADULT_PRODUCTS_AND_SERVICES",
  "MULTILEVEL_MARKETING",
  "LOANS_DEBT_COLLECTION_BAIL_BONDS",
];
const TotalFields = [
  {
    id: "end_business_id",
    label: "Business Id",
    required: true,
  },
  {
    id: "end_business_legal_name",
    label: "Legal Name",
    required: true,
  },
  {
    id: "end_business_website",
    label: "Website",
    required: false,
  },
  {
    id: "business_vertical",
    label: "Vertical",
    Autocomplete: true,
    required: false,
  },
  {
    id: "num_billing_cycles_with_partner",
    label: "Billing Cycles",
    type: "number",
  },
  {
    id: "street_address_1",
    label: "street address 1",
    group: "end_business_address",
    required: true,
  },
  {
    id: "street_address_2",
    label: "street address 2",
    group: "end_business_address",
  },
  {
    id: "city_or_town",
    label: "City",
    group: "end_business_address",
    required: true,
  },
  {
    id: "state_province_or_region",
    label: "State province",
    group: "end_business_address",
    required: true,
  },
  {
    id: "postal_code",
    label: "Postal code",
    group: "end_business_address",
    required: true,
  },
  {
    id: "country_code",
    label: "Country code",
    group: "end_business_address",
    Autocomplete: true,
    required: true,
  },
  {
    id: "amount",
    label: "Amount",
    group: "average_monthly_revenue_spend_with_partner",
    required: true,
    type: "number",
  },
  {
    id: "currency_code",
    label: "Currency code",
    Autocomplete: true,
    group: "average_monthly_revenue_spend_with_partner",
    required: true,
  },
];

const ApplyBvbp = (props) => {
  const fileInputRef = useRef(null);
  const {
    toggleBvbpDialog,
    bvbpDialog,
    classes,
    onBvbpSave,
    defaultData,
    aadhaarGstInfo,
    msmeInfo,
    rejectionDialog,
    setRejectionDialog,
    rejectionReason,
    setRejectionReason,
    onRejectHandler,
    wabaDetails,
    wabaId,
    wabaNumberId,
    displayNameStatus,
    hasWriteAccess,
    isSpam,
    hideStepActions,
  } = props;
  const [data, setData] = useState(defaultData);
  const [files, setFiles] = useState([]);
  const [required, setRequired] = useState();
  const [FileUrlObject, setFileUrlObject] = useState({});
  const [fBMInfo, setFBMInfo] = useState({});
  const uploadSizeWarning = bvbpUploadSizeWarning(
    files.filter((file) => file.name !== "undefined")
  );

  const onchangeHandler = (e, id, group) => {
    e.persist();
    if (group) {
      setData((prevState) => ({
        ...prevState,
        [group]: {
          ...prevState[group],
          [id]: e.target.value,
        },
      }));
    } else {
      setData((prevState) => ({
        ...prevState,
        [id]: e.target.value,
      }));
    }
  };

  const onCancelHandler = () => {
    setData({});
    setFiles([]);
    toggleBvbpDialog();
  };
  const removeFileHandler = (fileName) => {
    const tempFileArray = files.filter((file) => file.name != fileName);
    setFiles(tempFileArray);
  };

  const handleClick = () => {
    fileInputRef.current.click();
  };

  useEffect(() => {
    let validated = true;

    TotalFields?.forEach((element) => {
      if (element.required) {
        if (element.group) {
          const value = data[element.group]?.[element.id];
          validated =
            validated &&
            (typeof value === "string" ? value.trim() !== "" : false);
        } else {
          const value = data[element.id];
          validated =
            validated &&
            (typeof value === "string" ? value.trim() !== "" : false);
        }
      }
    });

    // Skip file validation if msmeInfo.docUrl is present

    validated =
      validated &&
      files.length <= 3 &&
      files.length !== 0 &&
      !files.some((file) => file?.size > BVBP_FILE_LIMIT_BYTES);

    setRequired(validated);
  }, [data, files, msmeInfo]);

  const handleFileChange = (event) => {
    event.persist();
    if (event.target?.files?.length > 0) {
      const selectedFiles = event.target.files[0];
      setFiles((prevFiles) => [...prevFiles, selectedFiles]);
    }
  };

  const uploadFileFromURL = async (url) => {
    try {
      // Fetch the image from the URL
      url = replaceDomainInData(url);
      const response = await fetch(url);
      const blob = await response?.blob();

      // Create a File object from the Blob
      const fileName = url?.split("/").pop(); // Extracting file name from URL
      const file = new File([blob], fileName, { type: blob.type });

      // Create a DataTransfer object and add the File object to it
      const dataTransfer = new DataTransfer();
      dataTransfer.items.add(file);

      // Trigger the change event manually
      const event = new Event("change", { bubbles: true });
      Object.defineProperty(event, "target", {
        value: { files: dataTransfer.files },
        writable: false,
      });

      if (event.target?.files?.length > 0) {
        const originalFile = event.target?.files[0];
        const renamedFile = new File([originalFile], fileName, {
          type: originalFile.type,
        });
        setFileUrlObject((prevUrls) => ({ ...prevUrls, [fileName]: url }));
        setFiles((prevFiles) => [...prevFiles, renamedFile]);
      }
    } catch (error) {
      console.error("Error uploading file:", error);
    }
  };
  useEffect(() => {
    const gstUrl =
      aadhaarGstInfo?.gstInfo?.gstUrlInfo?.fullUrl?.fullUrl ||
      aadhaarGstInfo?.gstInfo?.gstUrlInfo?.fullUrl ||
      aadhaarGstInfo?.gstInfo?.gstUrlInfo;

    if (gstUrl && gstUrl !== "undefined") {
      uploadFileFromURL(gstUrl);
    }

    // Add similar logic for Aadhaar URL if needed
    // const aadhaarUrl = aadhaarGstInfo?.aadhaarInfo?.aadhaarUrlInfo?.fullUrl;
    // if (aadhaarUrl && aadhaarUrl !== "undefined") {
    //   uploadFileFromURL(aadhaarUrl);
    // }

    fetchFBMInfo();
  }, []);

  const onSaveHandler = () => {
    const formData = new FormData();
    const validFiles = files.filter((file) => file.name !== "undefined");
    validFiles.forEach((file) => {
      formData.append(`business_documents[]`, file);
    });
    const tempData = { ...data };
    tempData.num_billing_cycles_with_partner =
      parseInt(tempData.num_billing_cycles_with_partner) || 2;

    tempData.average_monthly_revenue_spend_with_partner.amount = parseInt(
      tempData.average_monthly_revenue_spend_with_partner.amount
    );
    formData.append("end_business_id", tempData?.end_business_id);
    if (tempData?.business_vertical) {
      formData.append("business_vertical", tempData?.business_vertical);
    }
    formData.append(
      "end_business_legal_name",
      tempData.end_business_legal_name
    );
    if (tempData.end_business_website) {
      formData.append("end_business_website", tempData.end_business_website);
    }
    formData.append(
      "end_business_address",
      JSON.stringify(tempData.end_business_address)
    );
    formData.append(
      "average_monthly_revenue_spend_with_partner",
      JSON.stringify(tempData.average_monthly_revenue_spend_with_partner)
    );
    formData.append(
      "num_billing_cycles_with_partner",
      tempData.num_billing_cycles_with_partner
    );

    onBvbpSave(formData);
  };

  const fetchFBMInfo = () => {
    const payload = {
      fbBusinessId: defaultData?.end_business_id,
      wabaId,
      wabaNumberId,
      website: defaultData?.end_business_website,
    };
    axios
      .get(`${URL}/superadmin/fetch-fbm-meta-info`, {
        params: payload,
      })
      .then((res) => {
        setFBMInfo({
          name: res?.data?.businessInfo?.name,
          status: res?.data?.businessInfo?.verification_status,
        });
        const updateObj = {};
        // Meta's WABA owner wins over a possibly stale stored id;
        // bvbp-apply rejects any other id.
        if (res?.data?.businessInfo?.id || !defaultData.end_business_id) {
          updateObj.end_business_id = res?.data?.businessInfo?.id;
        }
        if (!defaultData.end_business_website) {
          updateObj.end_business_website = res?.data?.website;
        }
        // No GST on file (project skipped our KYC): start from the FBM name.
        if (!defaultData.end_business_legal_name && res?.data?.businessInfo?.name) {
          updateObj.end_business_legal_name = res.data.businessInfo.name;
        }
        if (res?.data?.healthStatus) {
          updateObj.healthStatus = res?.data.healthStatus;
        }
        setData({
          ...data,
          ...updateObj,
        });
      })
      .catch((e) => {
        console.error(e);
        setFBMInfo({});
      });
  };

  return (
    <>
      <Dialog
        onClose={toggleBvbpDialog}
        open={bvbpDialog}
        // closeDialog={toggleBvbpDialog}
        maxWidth={"md"}
        fullWidth
      >
        <DialogTitle id="simple-dialog-title" style={{ padding: "24px" }}>
          <Typography variant="h3">Apply for BVBP</Typography>
        </DialogTitle>
        <Box
          className={
            isSpam ? classes.spamWarningBanner : classes.safeInfoBanner
          }
        >
          {isSpam ? (
            <>
              <Warning className={classes.bannerIcon} />
              <Typography component="span" className={classes.bannerText}>
                This GST/document has been flagged as spam. Please verify
                carefully before proceeding.
              </Typography>
            </>
          ) : (
            <>
              <CheckCircle className={classes.bannerIcon} />
              <Typography component="span" className={classes.bannerText}>
                This GST/document has not been flagged as spam.
              </Typography>
            </>
          )}
        </Box>
        <Box className={classes.attemptsNote}>
          <InfoOutlined className={classes.attemptsNoteIcon} />
          <Typography component="span" variant="body2">
            Meta allows 3 submissions per client; after that the client
            verifies on Facebook themselves. Meta's result arrives later, not
            on Confirm. Documents should match the legal name and address
            below.
          </Typography>
        </Box>
        <DialogContent>
          {aadhaarGstInfo?.gstInfo && (
            <>
              <Grid
                container
                style={{
                  width: "100%",
                  border: "1px solid #b0b0b0",
                  margin: "10px 0px",
                  padding: "16px",
                  background: "#e9e9e9",
                  borderRadius: "8px",
                  display: "flex",
                  flexDirection: "column",
                }}
              >
                <Grid item>
                  <Typography
                    variant="h5"
                    style={{
                      fontWeight: "600",
                      marginBottom: "10px",
                      fontSize: "14px",
                    }}
                  >
                    {`G.S.T. Info`}
                  </Typography>
                </Grid>
                <Grid
                  item
                  style={{
                    display: "flex",
                    fontSize: "12px",
                    alignItems: "center",
                  }}
                >
                  <Typography
                    variant="h5"
                    style={{
                      fontWeight: "600",
                      marginRight: "10px",
                      fontSize: "12px",
                    }}
                  >
                    Directors :
                  </Typography>
                  {aadhaarGstInfo?.gstInfo?.directors?.length > 0
                    ? aadhaarGstInfo?.gstInfo?.directors
                      .map((director) => director.name)
                      .join(", ")
                    : "No directors available"}
                </Grid>
                <Grid
                  item
                  style={{
                    display: "flex",
                    fontSize: "12px",
                    alignItems: "center",
                  }}
                >
                  <Typography
                    variant="h5"
                    style={{
                      fontWeight: "600",
                      marginRight: "10px",
                      fontSize: "12px",
                    }}
                  >
                    Legal Name :
                  </Typography>
                  {aadhaarGstInfo?.gstInfo?.legalName}
                </Grid>
                <Grid
                  item
                  style={{
                    display: "flex",
                    fontSize: "12px",
                    alignItems: "center",
                  }}
                >
                  <Typography
                    variant="h5"
                    style={{
                      fontWeight: "600",
                      marginRight: "10px",
                      fontSize: "12px",
                    }}
                  >
                    Trade Name :
                  </Typography>
                  {aadhaarGstInfo?.gstInfo?.tradeName}
                </Grid>
              </Grid>
            </>
          )}

          {aadhaarGstInfo?.aadhaarInfo?.userName && (
            <Grid
              container
              style={{
                width: "100%",
                border: "1px solid #b0b0b0",
                margin: "10px 0px",
                padding: "16px",
                background: "#e9e9e9",
                borderRadius: "8px",
                display: "flex",
                flexDirection: "column",
              }}
            >
              <Grid item>
                <Typography
                  variant="h5"
                  style={{
                    fontWeight: "600",
                    marginBottom: "10px",
                    fontSize: "14px",
                  }}
                >
                  {`Aadhaar Info`}
                </Typography>
              </Grid>
              <Grid
                item
                style={{
                  display: "flex",
                  fontSize: "12px",
                  alignItems: "center",
                }}
              >
                <Typography
                  variant="h5"
                  style={{
                    fontWeight: "600",
                    marginRight: "10px",
                    fontSize: "12px",
                  }}
                >
                  Name :
                </Typography>
                {aadhaarGstInfo?.aadhaarInfo?.userName || ""}
              </Grid>
            </Grid>
          )}
          {(wabaDetails?.waba_ban_state || wabaDetails?.waba_Deleted) && (
            <Grid
              container
              style={{
                width: "100%",
                border: "1px solid #b0b0b0",
                margin: "10px 0px",
                padding: "16px",
                background: "#e9e9e9",
                borderRadius: "8px",
                display: "flex",
                flexDirection: "column",
              }}
            >
              <Grid item>
                <Typography
                  variant="h5"
                  style={{
                    fontWeight: "600",
                    marginBottom: "10px",
                    fontSize: "14px",
                  }}
                >
                  {`WABA Info`}
                </Typography>
              </Grid>
              <Grid
                item
                style={{
                  display: "flex",
                  fontSize: "12px",
                  alignItems: "center",
                }}
              >
                <Typography
                  variant="h5"
                  style={{
                    fontWeight: "600",
                    marginRight: "10px",
                    fontSize: "12px",
                  }}
                >
                  Status :
                </Typography>
                {wabaDetails?.waba_Deleted
                  ? "Deleted"
                  : wabaDetails?.waba_ban_state == "DISABLE"
                    ? "Disable"
                    : "Live"}
              </Grid>
            </Grid>
          )}

          {fBMInfo?.name && (
            <Grid
              container
              style={{
                width: "100%",
                border: "1px solid #b0b0b0",
                margin: "10px 0px",
                padding: "16px",
                background: "#e9e9e9",
                borderRadius: "8px",
                display: "flex",
                flexDirection: "column",
              }}
            >
              <Grid item>
                <Typography
                  variant="h5"
                  style={{
                    fontWeight: "600",
                    marginBottom: "10px",
                    fontSize: "14px",
                  }}
                >
                  {`Account Info`}
                </Typography>
              </Grid>
              <Grid
                item
                style={{
                  display: "flex",
                  fontSize: "12px",
                  alignItems: "center",
                }}
              >
                <Typography
                  variant="h5"
                  style={{
                    fontWeight: "600",
                    marginRight: "10px",
                    fontSize: "12px",
                  }}
                >
                  FBM Name :
                </Typography>
                {fBMInfo?.name || ""}
              </Grid>
              <Grid
                item
                style={{
                  display: "flex",
                  fontSize: "12px",
                  alignItems: "center",
                }}
              >
                <Typography
                  variant="h5"
                  style={{
                    fontWeight: "600",
                    marginRight: "10px",
                    fontSize: "12px",
                  }}
                >
                  FBM Status :
                </Typography>
                {fBMInfo?.status || ""}
              </Grid>
              <Grid
                item
                style={{
                  display: "flex",
                  fontSize: "12px",
                  alignItems: "center",
                }}
              >
                <Typography
                  variant="h5"
                  style={{
                    fontWeight: "600",
                    marginRight: "10px",
                    fontSize: "12px",
                  }}
                >
                  WABA Display Name Status :
                </Typography>
                {(displayNameStatus || "")
                  .toLowerCase()
                  .split("_")
                  .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
                  .join(" ") || ""}
              </Grid>
            </Grid>
          )}
          {data?.healthStatus?.can_send_message && (
            <Grid
              xs={12}
              md={12}
              container
              style={{
                width: "100%",
                border: "1px solid #b0b0b0",
                margin: "10px 0px",
                padding: "16px",
                background: "#e9e9e9",
                borderRadius: "8px",
                display: "flex",
                flexDirection: "column",
              }}
            >
              <Grid item>
                <Typography
                  variant="h5"
                  style={{
                    fontWeight: "600",
                    marginBottom: "10px",
                    fontSize: "14px",
                  }}
                >
                  {`Account Health Info`}
                </Typography>
              </Grid>
              <Grid
                item
                style={{
                  display: "flex",
                  fontSize: "12px",
                  alignItems: "center",
                }}
              >
                <Typography
                  variant="h5"
                  style={{
                    fontWeight: "600",
                    marginRight: "10px",
                    fontSize: "12px",
                  }}
                >
                  Can Send Message:
                </Typography>
                {data?.healthStatus?.can_send_message
                  .toLowerCase()
                  .split("_")
                  .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
                  .join(" ") || ""}
              </Grid>
              {data?.healthStatus?.entities.map((item) => (
                <Grid
                  item
                  style={{
                    display: "flex",
                    fontSize: "12px",
                    alignItems: "center",
                  }}
                >
                  <Typography
                    variant="h5"
                    style={{
                      fontWeight: "600",
                      marginRight: "10px",
                      fontSize: "12px",
                    }}
                  >
                    {`${item.entity_type
                      .toLowerCase()
                      .split("_")
                      .map(
                        (word) => word.charAt(0).toUpperCase() + word.slice(1)
                      )
                      .join(" ")}`}{" "}
                    :
                  </Typography>
                  {item.can_send_message
                    .toLowerCase()
                    .split("_")
                    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
                    .join(" ") || ""}
                </Grid>
              ))}
            </Grid>
          )}

          <Grid container>
            {TotalFields?.map((field) => (
              <>
                <Grid
                  container
                  md={6}
                  xs={12}
                  style={{ display: "flex", justifyContent: "space-around" }}
                >
                  <Grid item xs={4} md={2} container alignItems="center">
                    <Typography required variant="h5">
                      {field.label}
                      {field.required && (
                        <span style={{ color: "red", marginLeft: "1px" }}>
                          *
                        </span>
                      )}
                    </Typography>
                  </Grid>
                  <Grid
                    xs={8}
                    md={8}
                    style={{
                      display: "flex",
                      alignItems: "center",
                      width: "100%",
                    }}
                  >
                    <Grid
                      item
                      md={12}
                      style={{ display: "flex", width: "100%" }}
                    >
                      <Grid
                        item
                        xs={12}
                        md={12}
                        style={{ marginRight: 4, width: "100%" }}
                      >
                        {field.Autocomplete ? (
                          <Autocomplete
                            options={
                              field.id == "country_code"
                                ? currencyCode.map((option) => option)
                                : field.id == "business_vertical"
                                  ? business_vertical.map((option) => option)
                                  : countryCode.map((option) => option)
                            }
                            onChange={(e, value, reason) => {
                              if (field.group) {
                                setData((prevState) => ({
                                  ...prevState,
                                  [field.group]: {
                                    ...prevState[field.group],
                                    [field.id]: value,
                                  },
                                }));
                              } else {
                                setData((prevState) => ({
                                  ...prevState,
                                  [field.id]: value,
                                }));
                              }
                            }}
                            value={
                              (field.group
                                ? data[field.group]
                                  ? data[field.group][field.id]
                                  : ""
                                : data[field.id]) || ""
                            }
                            renderInput={(params) => (
                              <TextField
                                {...params}
                                className={classes.textFieldRoot}
                                InputProps={{ ...params.InputProps }}
                                style={{
                                  border: "1px solid ",
                                  background: "white",
                                }}
                              />
                            )}
                          />
                        ) : (
                          <TextField
                            style={{ width: "100%", padding: "3px 0px" }}
                            required
                            type={`${field.type
                              ? field.type == "number"
                                ? "number"
                                : "string"
                              : "string"
                              }`}
                            variant="outlined"
                            id={`${field.id}`}
                            classes={{
                              root: classes.textFieldRoot,
                            }}
                            className={classes.textFieldRoot}
                            margin="dense"
                            onChange={(e) =>
                              onchangeHandler(e, field.id, field?.group)
                            }
                            value={
                              (field.group
                                ? data[field.group]
                                  ? data[field.group][field.id]
                                  : ""
                                : data[field.id]) || ""
                            }
                          />
                        )}
                      </Grid>
                    </Grid>
                  </Grid>
                </Grid>
              </>
            ))}
            <Grid
              container
              md={6}
              xs={12}
              style={{ display: "flex", justifyContent: "space-around" }}
            >
              <Grid item xs={4} md={2} container alignItems="center">
                <Typography required variant="h5">
                  Documents
                  <span style={{ color: "red", marginLeft: "1px" }}>*</span>
                </Typography>
              </Grid>
              <Grid
                xs={8}
                md={8}
                style={{
                  display: "flex",
                  alignItems: "center",
                  width: "100%",
                }}
              >
                <Grid item md={12} style={{ display: "flex", width: "100%" }}>
                  <Grid
                    item
                    xs={12}
                    md={12}
                    style={{ marginRight: 4, width: "100%" }}
                  >
                    <div style={{ width: "100%", padding: "3px 0px" }}>
                      <input
                        type="file"
                        ref={fileInputRef}
                        style={{ display: "none" }}
                        accept=".pdf,.jpeg,.jpg,.png"
                        onChange={handleFileChange}
                      />
                    </div>
                    <Box onClick={handleClick}>
                      <Grid
                        item
                        md={12}
                        style={{
                          display: "flex",
                          width: "100%",
                          alignItems: "center",
                          justifyContent: "space-between",
                          cursor: "pointer",
                        }}
                        classes={{
                          root: classes.textFieldRoot,
                        }}
                      >
                        <Typography required variant="h5">
                          Upload File
                        </Typography>
                        <IconButton
                          color="primary"
                          size="small"
                          variant="filled"
                        >
                          <Publish />
                        </IconButton>
                      </Grid>
                    </Box>
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
            {files
              .filter((file) => file.name !== "undefined")
              .map((file) => (
                <FileDisplay
                  key={file.name}
                  classes={classes}
                  name={file.name}
                  url={FileUrlObject[file.name]}
                  removeFile={removeFileHandler}
                />
              ))}
            {uploadSizeWarning && (
              <Typography variant="body2" color="error">
                {uploadSizeWarning}
              </Typography>
            )}
          </Grid>
        </DialogContent>

        <DialogActions>
          <fieldset
            disabled={!hasWriteAccess}
            style={{
              border: "none",
              padding: 0,
              margin: 0,
              display: "flex",
              gap: "10px",
            }}
          >
            {msmeInfo && msmeInfo.docUrl ? (
              <Button
                onClick={() => {
                  window.open(replaceDomainInData(msmeInfo.docUrl));
                }}
                color="primary"
                variant="outlined"
              >
                View msme document
              </Button>
            ) : null}

            <Button
              onClick={onSaveHandler}
              variant="contained"
              color="primary"
              disabled={!required}
            >
              Confirm
            </Button>
            {!hideStepActions &&
              defaultData?.average_monthly_revenue_spend_with_partner
              ?.amount && (
                <Button
                  onClick={() => setRejectionDialog(!rejectionDialog)}
                  variant="contained"
                  color="primary"
                >
                  Edit step count
                </Button>
              )}
          </fieldset>
          <Button onClick={onCancelHandler} color="primary" variant="outlined">
            Cancel
          </Button>
        </DialogActions>
      </Dialog>

      <RejectKyc
        rejectionDialog={rejectionDialog}
        setRejectionDialog={setRejectionDialog}
        rejectionReason={rejectionReason}
        setRejectionReason={setRejectionReason}
        onRejectHandler={onRejectHandler}
      />
    </>
  );
};

const FileDisplay = (props) => {
  const { classes, name, removeFile, url } = props;
  return (
    <>
      <Grid
        container
        md={6}
        xs={12}
        marginTop={2}
        classes={{ root: classes.docBox }}
        style={{ display: "flex", justifyContent: "space-around" }}
      >
        <Grid
          item
          xs={4}
          md={2}
          container
          alignItems="center"
          style={{ display: "flex" }}
        ></Grid>
        <Grid
          xs={8}
          md={8}
          style={{
            display: "flex",
            alignItems: "center",
            width: "100%",
          }}
        >
          <Grid item md={12} style={{ display: "flex", width: "100%" }}>
            <Grid
              item
              xs={12}
              md={12}
              style={{ marginRight: 4, width: "100%" }}
            >
              <Box>
                <Grid
                  item
                  md={12}
                  style={{
                    display: "flex",
                    width: "100%",
                    alignItems: "center",
                    justifyContent: "space-between",
                    cursor: "pointer",
                  }}
                  classes={{
                    root: classes.textFieldRoot,
                  }}
                  onClick={() => {
                    window.open(replaceDomainInData(url));
                  }}
                >
                  <Typography required variant="h5">
                    {name.length > 20
                      ? name.substring(0, 20) + "..."
                      : `${name}`}
                  </Typography>
                  <IconButton
                    color="primary"
                    size="small"
                    variant="filled"
                    onClick={() => removeFile(name || "")}
                  >
                    <Clear />
                  </IconButton>
                </Grid>
              </Box>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </>
  );
};

const styles = (theme) => ({
  textFieldRoot: {
    backgroundColor: "rgb(240,240,240)",
    outline: "none",
    border: "none",
    borderRadius: "8px",
    padding: "4px 12px",
    width: "100%",
    boxShadow: "none",
    boxSizing: "border-box",
    fontFamily: "Roboto, sans-serif",
    fontSize: "8px",
    fontWeight: 500,
  },
  box: {
    padding: "10px",
  },
  docBox: {
    marginTop: "8px",
    marginBottom: "4px",
  },
  spamWarningBanner: {
    backgroundColor: "#ffebee", // light red
    color: "#b71c1c",
    border: "1px solid #ef9a9a",
    borderRadius: "8px",
    padding: "10px 16px",
    margin: "0 24px 12px",
    fontSize: "14px",
    fontWeight: 600,
    display: "flex",
    alignItems: "center",
  },
  safeInfoBanner: {
    backgroundColor: "#e8f5e9", // light green
    color: "#1b5e20",
    border: "1px solid #a5d6a7",
    borderRadius: "8px",
    padding: "10px 16px",
    margin: "0 24px 12px",
    fontSize: "14px",
    fontWeight: 600,
    display: "flex",
    alignItems: "center",
  },
  bannerIcon: {
    marginRight: "8px",
    fontSize: "20px",
  },
  attemptsNote: {
    color: "#616161",
    margin: "0 24px 12px",
    display: "flex",
    alignItems: "flex-start",
  },
  attemptsNoteIcon: {
    marginRight: "6px",
    fontSize: "18px",
    marginTop: "1px",
  },
  bannerText: {
    fontWeight: 600,
    fontSize: "15px",
  },
});

export default withStyles(styles)(ApplyBvbp);
